import { ActionContext } from 'vuex';

import { ActionClass, YearlySummaryState } from '../../../models';

import { YEARLY_SUMMARY_CONSTS } from '../yearly-summary.consts';

export class SetYearlySummaryAlreadyViewedAction implements ActionClass {

  public static execute({ commit }: ActionContext<YearlySummaryState, any>, viewed: boolean): void {
    commit(YEARLY_SUMMARY_CONSTS.mutations.setYearlySummaryAlreadyViewed, viewed);
  }

}
